module.exports = __webpack_public_path__ + "img/szh1.20849979.jpg";